// @flow

export default {
  fleet: {
    overview: (): string => "/dashboard/fleet",
    view: (fleetId: string): string =>
      `/dashboard/fleet/view/${fleetId}/overview`,
    edit: (fleetId: string): string => `/dashboard/fleet/edit/${fleetId}`
  },
  product: {
    attribute: {
      overview: (): string => "/dashboard/product/attribute",
      create: (): string => "/dashboard/product/attribute/create",
      view: (attributeId: string): string =>
        `/dashboard/product/attribute/view/${attributeId}`,
      edit: (attributeId: string): string =>
        `/dashboard/product/attribute/edit/${attributeId}`,
      editTrafficMappings: (attributeId: string): string =>
        `/dashboard/product/attribute/edit/${attributeId}/trafficMapping`,
      createTrafficMappings: (attributeId: string): string =>
        `/dashboard/product/attribute/create/${attributeId}/trafficMapping`
    },
    product: {
      overview: (): string => "/dashboard/product/product",
      create: (): string => "/dashboard/product/product/create",
      edit: (productId: string): string =>
        `/dashboard/product/product/edit/${productId}`
    }
  },
  rc: {
    createReport: (): string => "/dashboard/rc/tax-agency/create",
    vehicleList: (): string => "/dashboard/rc/manage-vehicles",
    editVehicle: (vehicleId: string): string =>
      `/dashboard/rc/manage-vehicles/${vehicleId}/edit`,
    viewVehicle: (vehicleId: string): string =>
      `/dashboard/rc/manage-vehicles/${vehicleId}`,
    createVehicle: (): string => "/dashboard/rc/manage-vehicles/create",
    vehicleLeaveNotice: (vehicleId: string): string =>
      `/dashboard/rc/manage-vehicles/${vehicleId}/notice`
  },
  transporter: {
    transporterApplication: (): string => "/dashboard/transporter/applications",
    transporterList: (): string => "/dashboard/transporter/search",
    transporterApplicationDetails: (signupEntryId: string): string =>
      `/dashboard/transporter/application/${signupEntryId}`,
    createTransporter: (): string => "/dashboard/transporter/create",
    edit: (transporterId: string): string =>
      `/dashboard/transporter/${transporterId}`,
    viewVehicle: (vehicleId: string): string =>
      `/dashboard/partner/reporting-center/${vehicleId}`,
    vehicleLeaveNotice: (vehicleId: string): string =>
      `/dashboard/partner/reporting-center/${vehicleId}/notice`
  },
  transporterWeb: {
    transporterApplication: (): string => "/dashboard/transporter/applications",
    transporterList: (): string => "/dashboard/transporter/search",
    createTransporter: (): string => "/dashboard/transporter/create",
    edit: (transporterId: string): string =>
      `/dashboard/transporter/${transporterId}`,
    createVehicle: (): string => "/dashboard/partner/vehicle-create",
    vehicleList: (): string => "/dashboard/partner/vehicles",
    editVehicle: (vehicleId: string): string =>
      `/dashboard/partner/vehicles/${vehicleId}`,
    vehicleLeaveNotice: (vehicleId: string): string =>
      `/dashboard/partner/reporting-center/${vehicleId}/notice`
  },
  vehicles: {
    list: (): string => "/dashboard/vehicle",
    edit: (vehicleId: string): string => `/dashboard/vehicle/${vehicleId}`,
    create: (): string => "/dashboard/vehicle/create",
    changeCar: (vehicleId: string): string =>
      `/dashboard/vehicle/${vehicleId}/change-car`,
    viewVehicle: (countryCode: string, carRegNo: string): string =>
      `/dashboard/vehicle/regno/${countryCode}/${carRegNo}`
  },
  roles: {
    edit: (roleId: string): string => `/dashboard/roles/edit/${roleId}`,
    create: (): string => "/dashboard/roles/create"
  },
  trafficManagement: {
    overview: (): string => "/dashboard/traffic-management",
    create: (): string => "/dashboard/traffic-management/create",
    edit: (id: string): string => `/dashboard/traffic-management/edit/${id}`
  },
  campaignZones: {
    campaignsOverview: (): string => "/dashboard/campaign-zones/campaigns",
    campaignCreate: (): string => "/dashboard/campaign-zones/campaign/create/",
    campaignClone: (id: string): string =>
      `/dashboard/campaign-zones/campaign/create/${id}`,
    campaignEdit: (id: string): string =>
      `/dashboard/campaign-zones/campaign/edit/${id}`,
    zonesOverview: (): string => "/dashboard/campaign-zones/zones",
    zoneCreate: (): string => "/dashboard/campaign-zones/zone/create/",
    zoneEdit: (id: string): string =>
      `/dashboard/campaign-zones/zone/edit/${id}`
  },
  vouchers: {
    overview: (): string => "/dashboard/vouchers/buckets",
    create: (): string => "/dashboard/vouchers/buckets/create",
    viewVoucher: (bucketId: string): string =>
      `/dashboard/vouchers/buckets/${bucketId}`,
    edit: (bucketId: string): string =>
      `/dashboard/vouchers/buckets/edit/${bucketId}`
  },
  driver: {
    overview: (): string => "/dashboard/driver/search",
    view: (driverId: string): string => `/dashboard/driver/view/${driverId}`,
    viewDriverFromRatingPage: (
      countryCode: string,
      driverLicenseId: string
    ): string =>
      `/dashboard/driver/countryCode/${countryCode}/licenseId/${driverLicenseId}`,
    create: (): string => "/dashboard/driver/create",
    edit: (id: string): string => `/dashboard/driver/edit/${id}`,
    addFleet: (id: string): string => `/dashboard/driver/add-fleet/${id}`
  },
  orders: {
    orderSearch: (): string => "/dashboard/orders/order-search",
    detailOrder: (orderId: string): string =>
      `/dashboard/orders/detail/${orderId}`,
    iframeDetailOrder: (orderId: string): string =>
      `/iframe/order-search/orders/detail/${orderId}`,
    manageOrders: (): string => "/dashboard/orders/manage-orders"
  },
  customerFeedback: {
    overview: (): string => "/dashboard/customer-feedback/overview",
    rating: (
      query: string,
      beginDate: ?string = null,
      endDate: ?string = null
    ): string => {
      if (beginDate && endDate)
        return `/dashboard/customer-feedback/rating?query=${query}&beginDate=${beginDate}&endDate=${endDate}`
      return `/dashboard/customer-feedback/rating?query=${query}`
    }
  },
  areas: {
    overview: (): string => "/dashboard/addresses/areas",
    create: (): string => "/dashboard/addresses/areas/create",
    edit: (id: string): string => `/dashboard/addresses/areas/edit/${id}`
  },
  backoffice: {
    overview: (): string => "/dashboard/backoffice/deductions"
  },
  driverRegistry: {
    driverApplicationDetails: (signupEntryId: string): string =>
      `/dashboard/driver/application/${signupEntryId}`
  }
}
